import { render, staticRenderFns } from "./MnvSignificanceTable.vue?vue&type=template&id=7d120e2b&scoped=true"
import script from "./MnvSignificanceTable.vue?vue&type=script&lang=js"
export * from "./MnvSignificanceTable.vue?vue&type=script&lang=js"
import style0 from "./MnvSignificanceTable.vue?vue&type=style&index=0&id=7d120e2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d120e2b",
  null
  
)

export default component.exports